import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1e86df93"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "signature-input" }
const _hoisted_2 = {
  key: 0,
  class: "signature-preview"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "d-flex gap-2 align-items-center" }
const _hoisted_6 = {
  class: "btn btn-sm btn-secondary",
  style: {"cursor":"pointer"}
}
const _hoisted_7 = {
  key: 0,
  class: "mt-2"
}

import { ref, onMounted, watch, nextTick } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SignatureInput',
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const { modelValue } = __props
const emit = __emit

const showCanvas = ref(false)
const canvasRef = ref<HTMLCanvasElement | null>(null)
let ctx: CanvasRenderingContext2D | null = null
let drawing = false
let lastX = 0
let lastY = 0

function setupCanvasSize() {
  const c = canvasRef.value
  if (!c) return
  const ratio = window.devicePixelRatio || 1
  const width = 400
  const height = 150
  c.width = width * ratio
  c.height = height * ratio
  c.style.width = width + 'px'
  c.style.height = height + 'px'
  ctx = c.getContext('2d')
  if (ctx) {
    ctx.scale(ratio, ratio)
    ctx.lineWidth = 2
    ctx.lineCap = 'round'
    ctx.strokeStyle = '#000'
  }
}

onMounted(() => setupCanvasSize())
// if canvas is toggled after mount, initialize when shown
watch(showCanvas, async (val) => {
  if (val) await nextTick()
  setupCanvasSize()
})

function getPointerPos(e: PointerEvent) {
  const c = canvasRef.value
  if (!c) return { x: 0, y: 0 }
  const rect = c.getBoundingClientRect()
  return { x: e.clientX - rect.left, y: e.clientY - rect.top }
}

function startDraw(e: PointerEvent) {
  drawing = true
  const pos = getPointerPos(e)
  lastX = pos.x
  lastY = pos.y
  try { (e.target as Element).setPointerCapture(e.pointerId) } catch (err) {}
}

function moveDraw(e: PointerEvent) {
  if (!drawing || !ctx) return
  const pos = getPointerPos(e)
  ctx.beginPath()
  ctx.moveTo(lastX, lastY)
  ctx.lineTo(pos.x, pos.y)
  ctx.stroke()
  lastX = pos.x
  lastY = pos.y
}

function endDraw(e: PointerEvent) {
  drawing = false
  try { (e.target as Element).releasePointerCapture(e.pointerId) } catch (err) {}
}

function clearCanvas() {
  const c = canvasRef.value
  if (!c || !ctx) return
  const ratio = window.devicePixelRatio || 1
  ctx.clearRect(0, 0, c.width / ratio, c.height / ratio)
  emit('update:modelValue', null)
}

function saveSignature() {
  const c = canvasRef.value
  if (!c) return
  const data = c.toDataURL('image/png')
  emit('update:modelValue', data)
  showCanvas.value = false
}

function handleFile(evt: Event) {
  const input = evt.target as HTMLInputElement
  const file = input.files?.[0]
  if (!file) return
  const reader = new FileReader()
  reader.onload = () => {
    const result = reader.result as string
    emit('update:modelValue', result)
  }
  reader.readAsDataURL(file)
  input.value = ''
}

function emitRemove() {
  emit('update:modelValue', null)
}

function download() {
  const a = document.createElement('a')
  a.href = modelValue || ''
  a.download = 'assinatura.png'
  document.body.appendChild(a)
  a.click()
  a.remove()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.modelValue)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("img", {
            src: _ctx.modelValue,
            alt: "Assinatura",
            style: {"max-width":"100%","max-height":"150px"}
          }, null, 8, _hoisted_3),
          _createElementVNode("div", { class: "mt-2 d-flex gap-2" }, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-sm btn-outline-secondary",
              onClick: emitRemove
            }, "Remover")
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-sm",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (showCanvas.value = !showCanvas.value))
            }, _toDisplayString(showCanvas.value ? 'Fechar' : 'Desenhar assinatura'), 1),
            _createElementVNode("label", _hoisted_6, [
              _createTextVNode(" Upload "),
              _createElementVNode("input", {
                type: "file",
                accept: "image/*",
                onChange: handleFile,
                class: "d-none"
              }, null, 32)
            ])
          ]),
          (showCanvas.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("canvas", {
                  ref_key: "canvasRef",
                  ref: canvasRef,
                  style: {"border":"1px solid #ddd","touch-action":"none","width":"100%","max-width":"400px","height":"150px","display":"block"},
                  onPointerdown: startDraw,
                  onPointermove: moveDraw,
                  onPointerup: endDraw,
                  onPointercancel: endDraw
                }, null, 544),
                _createElementVNode("div", { class: "mt-2 d-flex gap-2" }, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-sm",
                    onClick: saveSignature
                  }, "Salvar"),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-sm btn-outline-secondary",
                    onClick: clearCanvas
                  }, "Limpar")
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
  ]))
}
}

})